import { render, staticRenderFns } from "./htmlGameForm.vue?vue&type=template&id=3808106c&"
import script from "./htmlGameForm.vue?vue&type=script&lang=js&"
export * from "./htmlGameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports